import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { SuperOfficeCompanyModel } from '../../core/models/super-office-company.model';
import { SuperOfficePersonModel } from '../../core/models/super-office-person.model';
import { SuperOfficeProjectModel } from '../../core/models/super-office-project.model';
import { SuperOfficeSuggestionModel } from '../../core/models/super-office-suggestion.model';
import { SendTicketToSORequest } from '../../core/models/send-ticket-to-so-request.model';

@Injectable({ providedIn: 'root' })
export class SuperOfficeService {
    constructor(private httpClient: HttpClient) {}

    getCompanies(name: string): Observable<SuperOfficeCompanyModel[]> {
        return this.httpClient.get<SuperOfficeCompanyModel[]>(environment.apiInboxUrl + 'SupperOffice/Companies', {
            params: new HttpParams().set('query', name).set('skip', '0').set('take', '100'),
        });
    }

    getCompany(id: number): Observable<SuperOfficeCompanyModel[]> {
        return this.httpClient.get<SuperOfficeCompanyModel[]>(environment.apiInboxUrl + 'SupperOffice/Companies/' + id);
    }

    getPersons(name: string, companyId: number): Observable<SuperOfficePersonModel[]> {
        return this.httpClient.get<SuperOfficePersonModel[]>(environment.apiInboxUrl + 'SupperOffice/Persons', {
            params: new HttpParams().set('query', name).set('companyId', companyId).set('skip', '0').set('take', '100'),
        });
    }

    getProjects(name: string): Observable<SuperOfficeProjectModel[]> {
        return this.httpClient.get<SuperOfficeProjectModel[]>(environment.apiInboxUrl + 'SupperOffice/Projects', {
            params: new HttpParams().set('query', name).set('skip', '0').set('take', '100'),
        });
    }

    getSuggestions(email = ''): Observable<SuperOfficeSuggestionModel> {
        return this.httpClient.get<SuperOfficeSuggestionModel>(
            environment.apiInboxUrl + 'SupperOffice/Suggestions?email=' + encodeURIComponent(email),
        );
    }

    save(model: SendTicketToSORequest): Observable<void> {
        return this.httpClient.post<void>(environment.apiInboxUrl + 'SupperOffice/Tickets/', model);
    }
}
